const parseBoolean = (param: string): boolean => {
  if (!param) return false;
  const truthyValues = ['t', 'true', 'y', 'yes', '1'];
  return truthyValues.includes(param.trim().toLowerCase());
};

export default parseBoolean;
